export type GroupType = (typeof GroupType)[keyof typeof GroupType];

export const GroupType = {
    Default: 'Default',
    DynamicTenantGroup: 'DynamicTenantGroup',
} as const;
